import { useState } from "react";
import { Divider, makeStyles, TextareaAutosize } from "@material-ui/core";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { InputField } from "../../../../../components/input-field/InputField";
import { InputButton } from "../../../../../components/input-button/InputButton";
import { BusinessWithdrawTarificationService } from "../../../../../services/BusinessWithdrawTarificationService";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { validateFile } from "../../../../../common/Hooks";
import { Autocomplete } from "@material-ui/lab";
import { Height } from "@material-ui/icons";
import FaqService from "../../../../../services/FaqService";

interface AddFaqProps {
  submitCallback: () => void;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
  },
  modalBody: {
    width: "90%",
    padding: 10,
    border: "none",
  },

  antPickerDropdown: {
    zIndex: 100000,
  },
}));

export const AddFaq = (
  props: AddFaqProps
) => {
  const classes = useStyles();
  const intl = useIntl();
  const { formatMessage } = useIntl();
  const { submitCallback } = props;
  const [branchId, setBranchID] = useState(2);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [succeed, setSucceed] = useState(false);

  const formik = useFormik({
    initialValues: {
      question_fr: "",
      question_en: "",
      response_fr: "",
      response_en: "",
    },
    /*validationSchema: Yup.object().shape({
      question: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterQuestion" })
      ),
      response: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterResponse" })
      ),
    }),*/
    onSubmit: async (
      values,
      { setSubmitting, resetForm }: FormikHelpers<any>
    ) => {
      console.log(values);
      setError(false);
      try {
        const addFaqResult = await FaqService.addFaq(
          formik.values
        );
        if (
          addFaqResult.isSuccess &&
          addFaqResult.data.code === 100
        ) {
          resetForm({});
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
          submitCallback();
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);
    },
  });

  return (
    <>
      <Paper className={classes.modalBody}>
        <form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
          <Grid container spacing={2}>
            <Grid
              item
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              xs={12}
              sm={12}
              lg={12}
            >
              <Typography
                className={classes.modalTitle}
                variant="h4"
                component="h4"
              >
                <FormattedMessage id="sharedScreen.addFaqTitle" />
              </Typography>
            </Grid>
            {error && (
              <Grid item xs={12} sm={12} lg={12}>
                <Alert severity="error">
                  {errorMessage === "" && (
                    <FormattedMessage id="sharedScreen.thereWasAProblemAddingFaq" />
                  )}
                  {errorMessage !== "" && <p>{errorMessage}</p>}
                </Alert>
              </Grid>
            )}
            <Grid item xs={12} sm={12} lg={12}>
              <TextareaAutosize
                name="question_fr"
                value={formik.values.question_fr}
                onChange={formik.handleChange}
                aria-label={formatMessage({ id: "sharedScreen.faqQuestionFR" })}
                //minRows={3}
                placeholder={formatMessage({ id: "sharedScreen.faqQuestionFR" })}
                style={{ width: "100%", height:100 }}
              />

                  <br />
                  <br />

              <TextareaAutosize
                name="question_en"
                value={formik.values.question_en}
                onChange={formik.handleChange}
                aria-label={formatMessage({ id: "sharedScreen.faqQuestionEN" })}
                //minRows={3}
                placeholder={formatMessage({ id: "sharedScreen.faqQuestionEN" })}
                style={{ width: "100%", height:100 }}
              />

                    <br />
                    <br />
              <TextareaAutosize
                name="response_fr"
                value={formik.values.response_fr}
                onChange={formik.handleChange}
                aria-label={formatMessage({ id: "sharedScreen.faqResponseFR" })}
                //minRows={3}
                placeholder={formatMessage({ id: "sharedScreen.faqResponseFR" })}
                style={{ width: "100%", height:100 }}
              />

                    <br />
                    <br />
              <TextareaAutosize
                name="response_en"
                value={formik.values.response_en}
                onChange={formik.handleChange}
                aria-label={formatMessage({ id: "sharedScreen.faqResponseEN" })}
                //minRows={3}
                placeholder={formatMessage({ id: "sharedScreen.faqResponseEN" })}
                style={{ width: "100%", height:100 }}
              />
              
            </Grid>
            <br />
            <br />

            <Grid item xs={12} sm={12} lg={12} container direction="row">
              <InputButton
                disabled={formik.isSubmitting}
                fullWidth
                type="submit"
                variant="contained"
                color="secondary"
              >
                <FormattedMessage id="sharedScreen.addFaq" />
                {formik.isSubmitting && <CircularProgress size={30} />}
              </InputButton>
            </Grid>
            {succeed && (
              <Grid item xs={12} sm={12} lg={12}>
                <Alert severity="success">
                  <FormattedMessage id="sharedScreen.faqAddedSuccessfully" />
                </Alert>
              </Grid>
            )}
          </Grid>
        </form>
      </Paper>
    </>
  );
};
